/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/collab/';
export const SET_FEED = `${path}SET_FEED`;
export const SET_USER_FEED = `${path}SET_USER_FEED`;
export const SET_FEED_SIZE = `${path}SET_FEED_SIZE`;
export const SET_MAX_QUERY_SIZE = `${path}SET_MAX_QUERY_SIZE`;
export const SET_STATUS = `${path}SET_STATUS`
